import React, { Component } from 'react';
import _ from 'lodash';
import CtaSidebar from './CtaSidebar';

import data from '../data/dataEN.json';

class Person extends Component {
  constructor({ match }) {
    super();

    const person = _.chain(data.team)
      .map('people') // pluck all elements from data
      .flatten() // flatten the elements into a single array
      .filter({ slug: match.params.slug }) // exatract elements with a prop of 'foo'
      .value();

    console.log(person[0]);
    this.state = {
      person: person[0],
      cta: data.cta.sidebar,
    };
  }
  render() {
    return (
      <div>
        <div className="business-banner">
          <div className="hvrbox">
            <img src="/images/_bg/02.jpg" alt="Team" className="hvrbox-layer_bottom" />
            <div className="hvrbox-layer_top">
              <div className="container">
                <div className="overlay-text text-left">
                  <h3>{this.state.person.name}</h3>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="/">Home</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        <a href="/team">Team</a>
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="padding-top-large" />

        <div className="bussiness-project-details">
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-4">
                    <div className="project-img">
                      <img src={this.state.person.photo} alt={this.state.person.name} />
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="project-quick-info">
                      <ul>
                        <li>
                          <h3>{this.state.person.name}</h3>
                          <br />
                          {this.state.person.function ? this.state.person.function : 'No function available'}
                        </li>
                        <li>{this.state.person.desc ? this.state.person.desc : 'No desc available'}</li>
                        <li>
                          {' '}
                          <strong>In MMC from year:</strong>{' '}
                          <span>{this.state.person.inCompany ? this.state.person.inCompany : 'No data available'}</span>{' '}
                        </li>
                        <li>
                          {' '}
                          <strong>Location:</strong>{' '}
                          <span>
                            {this.state.person.location ? this.state.person.location : 'No location available'}
                          </span>{' '}
                        </li>
                        <li>
                          {' '}
                          <strong>Email:</strong>{' '}
                          <span>{this.state.person.email ? this.state.person.email : 'No email available'}</span>{' '}
                        </li>
                        <li>
                          {' '}
                          <strong>Phone:</strong>{' '}
                          <span>{this.state.person.phone ? this.state.person.phone : 'No phone available'}</span>{' '}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <CtaSidebar cta={this.state.cta} />
                <div className="padding-top-middle" />
              </div>
            </div>
          </div>
        </div>
        <div className="padding-top-large" />
      </div>
    );
  }
}

export default Person;



// WEBPACK FOOTER //
// ./src/components/Person.js